<template>
  <g>
    <path
      d="M12 20.0002L11.14 19.1402C9.96 17.9602 9.97 16.0402 11.16 14.8802L12 14.0602C11.61 14.0202 11.32 14.0002 11 14.0002C8.33 14.0002 3 15.3402 3 18.0002V20.0002H12ZM11 12.0002C13.21 12.0002 15 10.2102 15 8.00018C15 5.79018 13.21 4.00018 11 4.00018C8.79 4.00018 7 5.79018 7 8.00018C7 10.2102 8.79 12.0002 11 12.0002Z"
    />
    <path
      d="M16.18 19.7802C15.79 20.1702 15.15 20.1702 14.76 19.7802L12.69 17.6902C12.31 17.3002 12.31 16.6802 12.69 16.3002L12.7 16.2902C13.09 15.9002 13.72 15.9002 14.1 16.2902L15.47 17.6602L19.9 13.2002C20.29 12.8102 20.92 12.8102 21.31 13.2002L21.32 13.2102C21.7 13.6002 21.7 14.2202 21.32 14.6002L16.18 19.7802Z"
    />
  </g>
</template>
